import React from 'react';
import { useAuth0 } from '../../react-auth0-spa';

import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/pro-light-svg-icons';
import HeaderPortal from '../../layout/header/HeaderPortal';

import './Profile.sass';
import Loader from 'components/Loading/Loader';

interface Props {
	returnTo: string;
}

export const Profile = (props: Props) => {
	const { loading, user } = useAuth0();
	const { logout } = useAuth0();

	return (
		<div className="Profile">
			<HeaderPortal>My profile</HeaderPortal>

			{loading ? (
				<Loader></Loader>
			) : (
				<>
					<div className="infos">
						<img src={user.picture} alt="Profile" />
						<div>
							<h2>{user.name}</h2>
							<p>{user.email}</p>
						</div>
					</div>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Button
							onClick={(e) => {
								e.preventDefault();
								logout({ returnTo: props.returnTo });
							}}
						>
							<FontAwesomeIcon icon={faSignOut} /> &nbsp;Sign out
						</Button>
					</div>
				</>
			)}
		</div>
	);
};
